export const LOCAL_AUTH_HOST = "auth.localhost";
export const PROD_AUTH_HOST = "auth.atw.net";

export function isAtwAuthPublicHost(hostname: string): boolean {
  const h = hostname.split(":")[0].toLowerCase();
  return h === PROD_AUTH_HOST || h === LOCAL_AUTH_HOST;
}

export function localDevPortSuffix(origin?: string): string {
  if (typeof window !== "undefined" && window.location.port) {
    return `:${window.location.port}`;
  }
  const from = origin || import.meta.env.VITE_AUTH_ORIGIN || "";
  try {
    const u = new URL(from);
    return u.port ? `:${u.port}` : "";
  } catch {
    return "";
  }
}

export function atwAuthAppOrigin(): string {
  if (typeof window !== "undefined") {
    const h = window.location.hostname.toLowerCase();
    if (isAtwAuthPublicHost(h)) {
      return `${window.location.protocol}//${window.location.host}`;
    }
    if (h === "localhost" || h === "127.0.0.1" || h.endsWith(".localhost")) {
      return `http://${LOCAL_AUTH_HOST}${localDevPortSuffix()}`;
    }
  }
  return `https://${PROD_AUTH_HOST}`;
}

export function atwAuthSigninUrl(callbackUrl: string): string {
  const base = atwAuthAppOrigin().replace(/\/$/, "");
  return `${base}/auth/signin?callbackUrl=${encodeURIComponent(callbackUrl)}`;
}

export function atwAuthSignoutUrl(callbackUrl: string): string {
  const base = atwAuthAppOrigin().replace(/\/$/, "");
  return `${base}/auth/signout?callbackUrl=${encodeURIComponent(callbackUrl)}`;
}
